import { axiosInstance } from '@src/services/common';

export async function postPatternQuery<
  T extends PatternQueryResponseItemData = PatternQueryResponseItemData,
>(payload: PatternQueryPayload) {
  const response = await axiosInstance.post<{ data: PatternQueryResponse<T> }>(
    '/gm/v1/pattern/query',
    payload,
  );

  return response.data.data;
}

export async function postPatternsQuery<
  T extends PatternQueryResponseItemData = PatternQueryResponseItemData,
>(payload: PatternsQueryPayload) {
  const response = await axiosInstance.post<PatternsQueryResponse<T>>(
    '/gm/v1/patterns/query',
    payload,
  );

  return response.data;
}
